import { Heart, Leaf } from 'lucide-react'

export function CurrencyDisplay() {
  return (
    <div className="flex items-center justify-end gap-4 p-4">
      <div className="flex items-center gap-2 bg-white rounded-full px-4 py-2 shadow-sm">
        <div className="flex items-center gap-2">
          <Heart className="w-6 h-6 text-pink-500" />
          <span className="font-medium">132.50</span>
        </div>
        <div className="flex items-center gap-2">
          <Leaf className="w-6 h-6 text-green-500" />
          <span className="font-medium">218.25</span>
        </div>
      </div>
    </div>
  )
}

